import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=28253fb3&scoped=true"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28253fb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28253fb3')) {
      api.createRecord('28253fb3', component.options)
    } else {
      api.reload('28253fb3', component.options)
    }
    module.hot.accept("./DeleteConfirmation.vue?vue&type=template&id=28253fb3&scoped=true", function () {
      api.rerender('28253fb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utility/DeleteConfirmation.vue"
export default component.exports